import { render, staticRenderFns } from "./BugReportModal.vue?vue&type=template&id=8f064c8c&scoped=true"
import script from "./BugReportModal.vue?vue&type=script&lang=js"
export * from "./BugReportModal.vue?vue&type=script&lang=js"
import style0 from "./BugReportModal.vue?vue&type=style&index=0&id=8f064c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f064c8c",
  null
  
)

export default component.exports